export type ChecklistAnswer = boolean | null;

export enum ChecklistStatus {
  Complete = "complete",
  Warning = "warning",
}

export interface QuestionState {
  visible: boolean;
  isWarning: boolean;
}
